import { render, staticRenderFns } from "./LotItemsEditorPopup.vue?vue&type=template&id=36238242&scoped=true"
import script from "./LotItemsEditorPopup.vue?vue&type=script&lang=js"
export * from "./LotItemsEditorPopup.vue?vue&type=script&lang=js"
import style0 from "./LotItemsEditorPopup.vue?vue&type=style&index=0&id=36238242&prod&lang=css"
import style1 from "./LotItemsEditorPopup.vue?vue&type=style&index=1&id=36238242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36238242",
  null
  
)

export default component.exports